const isValidTitle = (title) => !/[&<>"']/.exec(title);

export default isValidTitle;
